import { STANDARD_REMOTE_APPLICATIONS } from '../consts';

export function isStandardRemoteApplication(appId: string) {
	return STANDARD_REMOTE_APPLICATIONS.includes(appId);
}
